import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomDate {
  formatDate(publicationDate: string): string | undefined {
    throw new Error('Method not implemented.');
  }
  normalizeDateTime(date: string | null): string | undefined {
    if (!date) return undefined;
    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Mês começa do zero
    const day = String(localDate.getDate()).padStart(2, '0');
    const hour = String(localDate.getHours()).padStart(2, '0');
    const min = String(localDate.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hour}:${min}:00.000Z`;
  }
}
